import { Injectable, inject } from '@angular/core';

import { FsApi, RequestConfig } from '@firestitch/api';

import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class IntegrationData {
  private _api = inject(FsApi);


  public get(id, query = {}, config: RequestConfig = {}): Observable<any> {
    return this._api.get(`integrations/${id}`, query, { key: 'integration', ...config });
  }

  public gets(data = {}, config: RequestConfig = {}): Observable<any> {
    return this._api.request('GET', 'integrations', data, { key: 'integrations', ...config });
  }

  public put(data, config: RequestConfig = {}): Observable<any> {
    return this._api.put(`integrations/${data.id}`, data, { key: 'integration', ...config });
  }

  public post(data, config: RequestConfig = {}): Observable<any> {
    return this._api.post('integrations', data, { key: 'integration', ...config });
  }

  public delete(data, config: RequestConfig = {}): Observable<any> {
    return this._api.delete(`integrations/${data.id}`, data, { key: 'integration', ...config });
  }

  public settings(config: RequestConfig = {}): Observable<any> {
    return this._api.get('integrations/settings', {}, { key: '', ...config });
  }

  public githubPut(data, config: RequestConfig = {}): Observable<any> {
    return this._api.put('integrations/github', data, { key: '', ...config });
  }

  public githubPost(data, config: RequestConfig = {}): Observable<any> {
    return this._api.post('integrations/github', data, { key: '', ...config });
  }

  public save(data): Observable<any> {
    if (data.id) {
      return this.put(data);
    }

    return this.post(data);
  }
}
